import { Link } from "react-router";

export function NotFound() {
  return (
    <main className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-xl font-semibold">Página não encontrada</h1>
      <Link to="/" className="mt-4 inline-block text-link underline">
        Voltar ao início
      </Link>
    </main>
  );
}
